<div class="list-item row" [class.error-border]="monitor.errorData" (contextmenu)="onContextMenu($event)"
  cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListData]="monitor" [cdkDropListEnterPredicate]="enterPredicate"
  [class.drop-border]="isDropEnabled" [class.active]="isDropActive"
  (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()" [id]="monitor.MonitorHandler"
  (click)="handleCheckBoxClick($event)">

  <div class="d-flex align-items-center col-xl-2 col-lg-4 col-4">
    <mat-checkbox disableRipple [checked]="isSelected" class="title" [matTooltip]="monitor.MonitorTitle">
      {{monitor.MonitorTitle}}</mat-checkbox>
  </div>

  <div class="d-flex col-xl-2 col-lg-4 align-items-center justify-content-center">
    <span class="text-truncate" [matTooltip]="monitor.Machine.Title">
      {{monitor.Machine.Title}}
    </span>
  </div>

  <div class="d-flex col-xl-1 col-lg-4 align-items-center justify-content-center">
    <span class="status-margined active text-lg-center text-xl-center" *ngIf="monitor.Status == screenStatuses.Playing">
      Playing </span>
    <span class="status-margined available text-lg-center text-xl-center"
      *ngIf="monitor.Status == screenStatuses.Waiting"> Available </span>
    <span class="status-margined pending text-lg-center text-xl-center"
      *ngIf="monitor.Status == screenStatuses.Pending"> Pending </span>
  </div>

  <div class="col-xl-2 col-lg-6 mt-sm-3 mt-lg-0 d-flex multiselect">
    <ng-select [(ngModel)]="monitor.AssignedPlaylist" [multiple]="false" [items]="playlists" [searchable]="false"
      (click)="$event.stopPropagation()" [markFirst]="false" [closeOnSelect]="true" placeholder="Select playlist"
      [clearable]="false" (change)="onPlaylistSelectChanged($event)">
      <ng-template ng-label-tmp let-item="item">
        {{item.PlaylistTitle}}
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        <p>{{item.PlaylistTitle}}</p>
      </ng-template>
    </ng-select>
  </div>

  <div class="col-xl-2 col-lg-6 mt-sm-3 mt-lg-0 d-flex multiselect">
    <ng-select [(ngModel)]="monitor.StartOptions" [multiple]="false" [items]="startOptions" [searchable]="false"
      (click)="$event.stopPropagation()" [markFirst]="false" [closeOnSelect]="true" placeholder="Select Start Option"
      [clearable]="false" (change)="refreshStartOptions($event)">
      <ng-template ng-label-tmp let-item="item">
        {{ item ? 'Playlist' : 'Default' }}
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        <p>{{ item ? 'Playlist' : 'Default' }}</p>
      </ng-template>
    </ng-select>
  </div>

  <div class="col-xl-3 col-lg-12 mt-sm-2 mt-lg-0 d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center justify-content-center action-buttons" (click)="$event.stopPropagation()">
      <button (click)="monitor.playPrevious()" *ngIf="monitor.Status == screenStatuses.Playing" mat-icon-button
        [disabled]="monitor.ScreenState.ScreenContentMode == contentModes.SingleApp" matTooltip="Play previous">
        <mat-icon svgIcon="fast_rewind"></mat-icon>
      </button>

      <button (click)="stopPlaylist()" *ngIf="monitor.Status == screenStatuses.Playing" mat-icon-button
        matTooltip="Stop Playlist">
        <mat-icon svgIcon="stop"></mat-icon>
      </button>

      <button (click)="startPlaylist()"
        *ngIf="monitor.IdAssignedPlaylist && monitor.Status == screenStatuses.Waiting" mat-icon-button
        matTooltip="Play now">
        <mat-icon svgIcon="play_arrow"></mat-icon>
      </button>

      <button (click)="monitor.playNext()" *ngIf="monitor.Status == screenStatuses.Playing" mat-icon-button
        [disabled]="monitor.ScreenState.ScreenContentMode == contentModes.SingleApp" matTooltip="Play next">
        <mat-icon svgIcon="fast_forward"></mat-icon>
      </button>

      <button (click)="monitor.refreshPlaylist()" *ngIf="monitor.Status == screenStatuses.Playing" mat-icon-button
        matTooltip="Refresh Playlist">
        <mat-icon svgIcon="refresh"></mat-icon>
      </button>

      <button (click)="schedule()" *ngIf="monitor.IdAssignedPlaylist" mat-icon-button matTooltip="Schedule Playlist">
        <mat-icon svgIcon="schedule"></mat-icon>
      </button>
    </div>

    <div class="d-flex align-items-center monitor-tags mx-2">
      <div>
        <mat-icon [ngStyle]="{ 'fill': monitorTag.Color }" *ngFor="let monitorTag of assignedMonitorTags$ | async"
        class="tag__icon" svgIcon="tag-icon"></mat-icon>
      </div>
    </div>


    <div class="version">
      <span>{{monitor.DesktopVersion}}</span>
    </div>
  </div>
</div>
